import Vue from 'vue'
import App from './App.vue'
import dataV from '@jiaminghi/data-view'
// 第一步: 引入router 插件
import VueRouter from 'vue-router'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import $http from '@/api/request.js'
import Axios from 'axios'
Vue.prototype.$axios = Axios //调用时使用this. $axios()

Vue.use(ElementUI);
Vue.config.productionTip = false
// 使用插件
Vue.use(VueRouter)
Vue.use(dataV)
Vue.config.productionTip = false

new Vue({
	el: '#app',
	// 解析App模板
	render: h => h(App),
	// 使用路由
	router

}).$mount('#app')